import { useProductInformationQuery } from "entities/products/graphql/product-information.queries.generated"
import { useProductObjCache } from "entities/products/model/store/useProductObjCache"
import { useVariantKey } from "entities/products/model/useVariantKey"

import { useEnrichedProductInformation } from "./useEnrichedProductInformation"

interface UseProductInformationArgs {
  variantKey: string
  configurationKey?: string | null
  dimensioningKey?: string | null
  parentProductType?: string | null
}

export function useProductInformation({
  variantKey,
  configurationKey = "",
  dimensioningKey = "",
  parentProductType
}: UseProductInformationArgs) {
  const { data, previousData, loading } = useProductInformationQuery({
    variables: {
      variantKey,
      configurationKey: encodeURIComponent(configurationKey || ""),
      dimensioningKey: dimensioningKey ?? ""
    }
  })

  const productInformationData =
    data?.productInformation ?? previousData?.productInformation

  const { getCacheForVariantKey } = useProductObjCache()
  const { productType } = useVariantKey(variantKey)

  const parentCacheEntry = parentProductType
    ? getCacheForVariantKey(parentProductType)
    : undefined

  const title =
    parentCacheEntry?.addons?.[productType]?.title ||
    productInformationData?.title ||
    productType

  const productInformation = useEnrichedProductInformation(
    productInformationData
  )

  return {
    productInformation,
    title,
    isLoading: loading
  }
}
